module.exports = __webpack_public_path__ + "static/media/img_5.70ad1e03.png";